/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductListAnalyticsListing,
    AdminProductListAnalyticsListingFromJSON,
    AdminProductListAnalyticsListingFromJSONTyped,
    AdminProductListAnalyticsListingToJSON,
} from './AdminProductListAnalyticsListing';

/**
 * 
 * @export
 * @interface AdminProductListAnalytics
 */
export interface AdminProductListAnalytics {
    /**
     * 
     * @type {string}
     * @memberof AdminProductListAnalytics
     */
    computedAt: string;
    /**
     * 
     * @type {Array<AdminProductListAnalyticsListing>}
     * @memberof AdminProductListAnalytics
     */
    listings: Array<AdminProductListAnalyticsListing>;
    /**
     * Severity is the worst listing severity (AdminListingSeverity values).
     * @type {string}
     * @memberof AdminProductListAnalytics
     */
    severity: string;
}

export function AdminProductListAnalyticsFromJSON(json: any): AdminProductListAnalytics {
    return AdminProductListAnalyticsFromJSONTyped(json, false);
}

export function AdminProductListAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductListAnalytics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'computedAt': json['computedAt'],
        'listings': ((json['listings'] as Array<any>).map(AdminProductListAnalyticsListingFromJSON)),
        'severity': json['severity'],
    };
}

export function AdminProductListAnalyticsToJSON(value?: AdminProductListAnalytics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'computedAt': value.computedAt,
        'listings': ((value.listings as Array<any>).map(AdminProductListAnalyticsListingToJSON)),
        'severity': value.severity,
    };
}

